export default __webpack_public_path__ + "static/highjump-58b87155e833f6ec7cbecdbe878e91c1.png";